import React from 'react';
import Layout from '../layout/Layout';
import './LegalPage.css';

const Impressum = () => {
  return (
    <Layout>
      <div className="legal-page">
        <div className="legal-container">
          <h1 className="legal-title">Impressum</h1>

        <section className="legal-section">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            <strong>ANTICIPATER GmbH</strong><br />
            Alter Schlachthof 39<br />
            76131 Karlsruhe<br />
            Deutschland
          </p>
        </section>

        <section className="legal-section">
          <h2>Vertreten durch</h2>
          <p>Thorsten Reiser</p>
        </section>

        <section className="legal-section">
          <h2>Kontakt</h2>
          <p>
            Telefon: +49 (0) 721 619 025 28<br />
            E-Mail: impressum@anticipater.com
          </p>
        </section>

        <section className="legal-section">
          <h2>Registereintrag</h2>
          <p>
            Eintragung im Handelsregister<br />
            Registergericht: Amtsgericht Mannheim<br />
            Registernummer: HRB 752025
          </p>
        </section>

        <section className="legal-section">
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE370089490
          </p>
        </section>

        <section className="legal-section">
          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
          <p>
            Thorsten Reiser<br />
            Alter Schlachthof 39<br />
            76131 Karlsruhe
          </p>
        </section>

        <section className="legal-section">
          <h2>EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
            <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a>
            . Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </section>

        <section className="legal-section">
          <h2>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
          <p>
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Impressum;
